// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"396":"styles/admin-editor.modern","999":"styles/app.modern"}[chunkId] + ".css";
};